/**
 * Extracts the sentence containing the clicked word or phrase from article content.
 */
export function extractSentenceContext(content: string, needle: string): string {
  const lowerContent = content.toLowerCase()
  const lowerNeedle = needle.toLowerCase().trim()
  let idx = lowerContent.indexOf(lowerNeedle)
  if (idx < 0 && lowerNeedle.includes(' ')) {
    const firstWord = lowerNeedle.split(/\s+/)[0]
    idx = lowerContent.indexOf(firstWord)
  }
  if (idx < 0) {
    return content.slice(0, Math.min(content.length, 200)).trim()
  }

  return extractSentenceContextAtOffset(content, idx)
}

/**
 * Extract the sentence around a known character offset (preferred for clicks),
 * so we don't accidentally pick the first occurrence or match substrings.
 */
export function extractSentenceContextAtOffset(content: string, offset: number): string {
  if (!content) return ''
  const idx = Math.min(Math.max(0, offset), content.length - 1)

  let start = idx
  while (start > 0 && !/[.!?]/.test(content[start - 1])) start--
  if (start > 0 && /[.!?]/.test(content[start - 1])) start++
  while (start < content.length && /\s/.test(content[start])) start++

  let end = idx
  while (end < content.length && !/[.!?]/.test(content[end])) end++
  if (end < content.length) end++

  return content.slice(start, end).trim()
}
